// extracted by mini-css-extract-plugin
module.exports =  {"cpAcccordionHeader":"DetailsPage_cpAcccordionHeader__nps7S","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__veSnS"};